module.exports = __webpack_public_path__ + "static/media/dublin-royal.ad7f9326.png";